import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core'
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {CoreModule} from "../../../../core.module";

@Component({
    selector: 'app-anonymize-card',
    templateUrl: './anonymize-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CoreModule],
    standalone: true
})
export class AnonymizeCardComponent {

  @Input() public itemName = '';
  @Input() public disabled = false;
  @Input() public showAsCard = true;

  @Output() public anonymizeConfirmed: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('confirmModal') public confirmModal!: TemplateRef<never>;

  public confirmModalRef?: BsModalRef;

  public action() {
    this.confirmModalRef = this.bsModalService.show(this.confirmModal);
  }

  public confirm() {
    this.confirmModalRef?.hide();
    this.anonymizeConfirmed.emit();
  }

  constructor(private readonly bsModalService: BsModalService) {}
}
